import React, { memo } from 'react';
import DataGrid, { Column } from 'devextreme-react/data-grid';

const Milestones = memo(function Milestones({ data }) {

    if (data) {
        return (
            <DataGrid
                dataSource={data}
                columnAutoWidth={true}
                showBorders={true}
            >
                <Column dataField="billingCode" />
                <Column dataField="taskName" />
                <Column dataField="completedPercentage" caption="Completed" format="percent"/>
                <Column dataField="endDate" caption="Due" dataType="date"/>
            </DataGrid>
        )
    }
});

export default Milestones;